import React, { useState, SyntheticEvent, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { EditReferrerProfilePage } from 'views/Profiles/Referrers/EditReferrerProfilePage';
import { EditApplicantProfilePage } from 'views/Profiles/Applicant/EditApplicantProfilePage';
import { EditMentorProfilePage } from 'views/Profiles/Mentor/EditMentorProfilePage';
import { useAuth } from 'app/ProviderAuth';
import { Box, Container, Tabs, Tab } from '@mui/material';
import { hasValidApplicantProfile, getApplicantsByUid, getReferrer } from 'apis';
import { Applicant, Referrer } from 'types';

const APPLICANT = 'applicant';
const REFERRER = 'referrer';
const MENTOR = 'mentor';
type ProfileType = typeof APPLICANT | typeof REFERRER | typeof MENTOR;

export const EditProfilePage = () => {
  const { user, isReferrer, isMentor } = useAuth();
  const [searchParams] = useSearchParams();
  const profileType = searchParams.get('profileType');
  const [isValidProfile, setisValidProfile] = useState(false);
  const defaultProfileType: ProfileType =
    [APPLICANT, REFERRER, MENTOR].includes(profileType as ProfileType)
      ? (profileType as ProfileType) : APPLICANT;
  const [selectedStatus, setSelectedStatus] =
    useState<ProfileType>(defaultProfileType);
  const [applicantData, setApplicantData] = useState<Applicant| undefined>(undefined);
  const [referrerData, setReferrerData] = useState<Referrer| undefined>(undefined);
  const [referrerDocID, setReferrerDocID] = useState<string>('');
  
  const handleButtonClick = (_: SyntheticEvent, status: ProfileType) => {
    setSelectedStatus(status);
  };
  
  useEffect(() => {
    if (user) {
      const checkValidProfile = async () => {
        const validProfile = await hasValidApplicantProfile(user.uid);
        setisValidProfile(validProfile);
      };
      const fetchData = async () => {
        const applicantSnapshot = await getApplicantsByUid(user.uid);
        const referrerSnapshot = await getReferrer(user.uid);
        setApplicantData(applicantSnapshot.data());
        setReferrerData(referrerSnapshot.data());
        setReferrerDocID(referrerSnapshot.id);
      };
      checkValidProfile();
      fetchData();
    }
  }, [user, setApplicantData, setReferrerData]);
  
  const backToProfile = () => {
    setSelectedStatus(APPLICANT);
  }
  return (
    <Container>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', maxWidth: '852px', mx: 'auto', mt: '24px'}}>
        <Tabs value={selectedStatus} onChange={handleButtonClick} centered >
          <Tab
            value={APPLICANT}
            label="個人資料"
            sx={{ fontSize: '16px' }}
          />
          {(isReferrer && isValidProfile) ? (
            <Tab
              value={REFERRER}
              label="推薦人資料"
              sx={{ fontSize: '16px' }}
            />
          ) : null}
          {isMentor ? (
            <Tab
              value={MENTOR}
              label="導師資料"
              sx={{ fontSize: '16px' }}
            />
          ) : null}
        </Tabs>
      </Box>

      <Box sx={{ display: selectedStatus === APPLICANT ? 'block' : 'none' }}>
        <EditApplicantProfilePage ReferrerData={referrerData} ApplicantData={applicantData} setApplicant={setApplicantData}/>
      </Box>
      {(isReferrer && isValidProfile) ? (
        <Box sx={{ display: selectedStatus === REFERRER ? 'block' : 'none' }}>
          <EditReferrerProfilePage
            referrerData={referrerData!}
            setReferrer={setReferrerData}
            referrerDocID={referrerDocID}
            visible={selectedStatus === REFERRER}
            backToProfile={backToProfile}
          />
        </Box>
      ) : null}
      {isMentor ? (
        <Box sx={{ display: selectedStatus === MENTOR ? 'block' : 'none' }}>
          <EditMentorProfilePage />
        </Box>
      ) : null}
    </Container>
  );
};
